module.exports = "<h2 mat-dialog-title>Adicionar nova Pasta</h2>\r\n<mat-dialog-content>\r\n  <p>Qual o nome da pasta nova?</p>\r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n    <form #form='ngForm' (ngSubmit)='onSubmit(form)'>\r\n        <input type=\"text\" placeholder=\"Nome da nova pasta\" [(ngModel)]=\"nomePasta\" name=\"nomePasta\" class=\"input-txt\" required>\r\n        <button mat-button [disabled]=\"!form.form.valid\" class=\"btn\" type=\"submit\">Salvar Nova Pasta</button>\r\n    </form>\r\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/dialog-addPastaBoleto.html
// module id = ./src/app/profile/dialog-addPastaBoleto.html
// module chunks = main